<template>
  <van-config-provider :theme-vars="themeVars">
    <div class="index-list">
      <div class="header">
        <div class="left">
          <van-search v-model="searchValue" placeholder="请输入搜索关键词" />
        </div>
        <div class="right">
          <span class="btn" @click="searchEvt">搜索</span>
        </div>
      </div>
      <div class="body">
        <van-index-bar
          :index-list="indexList"
          :z-index="5"
          highlight-color="#4275FD"
          v-show="!searchList.length"
        >
          <div
            class="group-item"
            :key="groupIndex"
            v-for="(group, groupIndex) in localList"
          >
            <van-index-anchor :index="group.initial">{{
              group.initial
            }}</van-index-anchor>
            <div class="list">
              <div
                class="item"
                :key="index"
                v-for="(item, index) in group.data"
                @click="itemClick(item)"
              >
                <div class="left">
                  <van-radio
                    :name="item.userIndex"
                    :checked="item.checked == 'checked'"
                  >
                    <template #icon="props">
                      <van-image
                        class="img-icon"
                        width="18px"
                        height="18px"
                        :src="
                          props.checked
                            ? require('@/assets/image/common/checked.png')
                            : require('@/assets/image/common/un_checked.png')
                        "
                      />
                    </template>
                  </van-radio>
                </div>
                <div class="middle">
                  <van-image round width="32" height="32" :src="item.headUrl" />
                </div>
                <div class="right">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </van-index-bar>
        <div class="list" v-show="searchList.length">
          <div
            class="item"
            :key="index"
            v-for="(item, index) in searchList"
            @click="itemClick(item)"
          >
            <div class="left">
              <van-radio
                :name="item.userIndex"
                :checked="item.checked == 'checked'"
              >
                <template #icon="props">
                  <van-image
                    class="img-icon"
                    width="18px"
                    height="18px"
                    :src="
                      props.checked
                        ? require('@/assets/image/common/checked.png')
                        : require('@/assets/image/common/un_checked.png')
                    "
                  />
                </template>
              </van-radio>
            </div>
            <div class="middle">
              <van-image round width="32" height="32" :src="item.headUrl" />
            </div>
            <div class="right">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </van-config-provider>
</template>

<script>
import { ref, toRefs, computed, watch, onMounted } from "vue";

export default {
  name: "IndexLists",
  props: {
    checkType: {
      type: String,
      default: "multiple",
    },
    defaultUserIndexs: {
      type: Array,
      default() {
        return [];
      },
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  setup(props, { emit }) {
    let { checkType } = toRefs(props);
    const themeVars = ref({
      buttonDefaultHeight: "36px",
    });

    const { list, defaultUserIndexs } = toRefs(props);
    const indexList = computed(() => {
      let tempList = [];
      list.value.map((item) => {
        tempList.push(item.initial);
      });
      return tempList;
    });

    const localList = ref([]);
    watch([defaultUserIndexs, list], ([defaultUserIndexs, list]) => {
      if (list && list.length) {
        list.map((item) => {
          if (item.data && item.data.length) {
            item.data.map((child) => {
              if (
                defaultUserIndexs.some(
                  (userIndex) => userIndex == child.userIndex
                )
              ) {
                child.checked = "checked";
              } else {
                child.checked = "unChecked";
              }
            });
          }
        });
        localList.value = [...list];
        // getCheckedList();
      }
    });

    // 修复首次进来不操作导致返回空数组问题
    onMounted(() => {
      setTimeout(() => {
        getCheckedList();
      }, 500);
    });

    const itemClick = (item) => {
      if (checkType.value === "single") {
        // 单选模式
        localList.value.map((group) => {
          group.data.map((groupItem) => {
            if (groupItem.userIndex !== item.userIndex) {
              groupItem.checked = "unChecked";
            }
          });
        });
      }
      if (item.checked == "checked") {
        item.checked = "unChecked";
      } else {
        item.checked = "checked";
      }
      getCheckedList();
    };

    const checkedList = ref([]);
    const getCheckedList = () => {
      let list = [];
      localList.value.map((group) => {
        group.data.map((item) => {
          if (item.checked == "checked") {
            list.push(item);
          }
        });
      });
      checkedList.value = list;
      emit("changeIndexList", checkedList.value);
    };

    const searchValue = ref("");
    const searchList = ref([]);
    const formatSearchList = () => {
      if (searchValue.value) {
        localList.value.map((group) => {
          group.data.map((item) => {
            if (item.name.indexOf(searchValue.value) !== -1) {
              searchList.value.push(item);
            }
          });
        });
      } else {
        searchList.value = [];
      }
    };
    const searchEvt = () => {
      formatSearchList();
    };
    watch(searchValue, (searchValue) => {
      if (searchValue) {
        formatSearchList();
      } else {
        searchList.value = [];
      }
    });

    return {
      themeVars,
      searchValue,
      formatSearchList,
      searchEvt,
      searchList,
      indexList,
      localList,
      itemClick,
      checkedList,
      getCheckedList,
    };
  },
};
</script>

<style lang="less" scoped>
.van-config-provider {
  height: 100%;
}
.index-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    display: flex;
    background-color: #fff;
    .left {
      flex: 1;
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
  }
  .body {
    flex: 1;
    overflow-y: auto;
  }
}
.item {
  display: flex;
  align-items: center;
  height: 54px;
  padding: 0 15px;
  background-color: #fff;
  &:last-child {
    .right {
      border-bottom: none;
    }
  }
  .left {
  }
  .middle {
    display: flex;
    align-items: center;
    margin-left: 12px;
  }
  .right {
    display: flex;
    flex: 1;
    align-items: center;
    height: 100%;
    border-bottom: 1px solid #e5e5e5;
    margin-left: 15px;
  }
}

/deep/ .van-index-anchor {
  display: flex;
  align-items: center;
  height: 34px;
  background-color: #f2f4f9;
}
</style>